import { useEffect } from 'react';
import { useSupabase, useAuth } from '../providers/SupabaseProvider';
import { NotificationType } from '../providers/NotificationProvider';

export function useNotificationPolling(addNotification: (message: string, type?: NotificationType, options?: NotificationOptions) => void) {
  const supabase = useSupabase();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    let canceled = false;

    const fetchNotifications = async () => {
      const { data, error } = await supabase
        .from('user_notifications')
        .select('id, title, message, type')
        .eq('user_id', user.id)
        .eq('is_read', false)
        .order('created_at', { ascending: true });

      if (error || !data) return;

      for (const n of data) {
        if (canceled) return;
        addNotification(n.title || n.message, (n.type as NotificationType) || 'info', { body: n.message });
        await supabase
          .from('user_notifications')
          .update({ is_read: true, read_at: new Date().toISOString() })
          .eq('id', n.id);
      }
    };

    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000);
    return () => {
      canceled = true;
      clearInterval(interval);
    };
  }, [supabase, user, addNotification]);
}
